import React from 'react';

function MenuDivider() {
  return <li role="separator" className="divider" />;
}

export default MenuDivider;
